import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionStates } from '../../permission-controller/root';
import { RolePricingSchemeLinkFeatureKey } from '../reducers/role-pricing-scheme-link.reducers';
import { RolePricingSchemeLinkStates } from '../states';
import { RolePricingSchemeLinkState } from '../states/role-pricing-scheme-link.states';

export const selectTeamPermFeature = createFeatureSelector<RolePricingSchemeLinkState>(RolePricingSchemeLinkFeatureKey);

// export const selectGuid = (state: PermissionStates) => state.permissions.teamPerm.selectedGuid;
export const selectRequiresUpdate = (state: PermissionStates) => state.permissions.rolePricingSchemeLink.updateAgGrid;
export const selectRolePricingSchemeLink = (state: PermissionStates) => state.permissions.rolePricingSchemeLink.selectedRolePricingSchemeLink;
